import { createStore } from 'vuex'

export default createStore({
  state: {
    onboardSeen: false,
    popupSeen: false,
    navigation: [
      'menu midi',
      'menu soir',
      'expériences',
      'établissements',
      'carrières',
      'FAQ',
      'contact',
    ],
  },
  getters: {
    onboardSeen: (state) => state.onboardSeen,
    popupSeen: (state) => state.popupSeen,
    navigation: (state) => state.navigation,
  },
  mutations: {
    setOnboardSeen(state) {
      state.onboardSeen = true
    },
    setPopupSeen(state) {
      state.popupSeen = true
    },
  },
  actions: {},
  modules: {},
})
